import { render, staticRenderFns } from "./BancoDeCartasTRCriar.vue?vue&type=template&id=0593c87c"
import script from "./BancoDeCartasTRCriar.vue?vue&type=script&lang=js"
export * from "./BancoDeCartasTRCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports